export default "__VITE_ASSET__0ef69971__"